import { render, staticRenderFns } from "./ModalEditOrdenOrion.vue?vue&type=template&id=1be43372"
import script from "./ModalEditOrdenOrion.vue?vue&type=script&lang=js"
export * from "./ModalEditOrdenOrion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports